import { AlertTriangle } from 'lucide-react'

interface RunFailureBannerProps {
  message: string
  phaseName?: string
  stepName?: string
}

export function RunFailureBanner({ message, phaseName, stepName }: Readonly<RunFailureBannerProps>) {
  return (
    <div className="mt-3" role="alert" data-testid="run-failure-banner">
      <div className="rounded-md border border-danger-foreground bg-danger px-4 py-3">
        <div className="flex items-start gap-3">
          <AlertTriangle className="h-5 w-5 shrink-0 text-danger-foreground mt-0.5" aria-hidden />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-danger-foreground">Run failed</p>
            <p className="mt-1 text-sm text-danger-foreground">
              {phaseName && stepName && (
                <>
                  Failed on <span className="font-medium">{phaseName}</span> {'→'} <span className="font-medium">{stepName}</span>.{' '}
                </>
              )}
              {message}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
